(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(['jquery'], factory);
	} else if (typeof module === 'object' && module.exports) {
		// Node/CommonJS
		module.exports = factory(jQuery)
	} else {
		// Browser globals
		window.BEM = factory(jQuery);
	}
}(function ($) {
	var options = {
		prefix: 'b_',
		elementSeparator: '__',
		modifierSeparator: '--'
	};

	function getClasses(node) {
		var result = {
				block: "",
				element: "",
				modifier: []
			},
			klass;

		node = $(node);

		klass = node.attr("class");

		if (!klass) {
			return result;
		}

		$.each(klass.split(" "), function() {
			if (this.substr(0, options.prefix.length) === options.prefix) {
				var sanitizedString = $.trim(this.substr(options.prefix.length));
				var classSplit = sanitizedString.split(options.elementSeparator);
				var blockString = classSplit[0];

				var blockSplit = blockString.split(options.modifierSeparator);

				result["block"] = blockSplit[0];

				if (blockSplit.length === 2) {
					result["modifier"].push(blockSplit[1]);
					return true;
				}

				if (classSplit.length > 1) {
					elementSplit = classSplit[1].split(options.modifierSeparator);

					result["element"] = elementSplit[0];

					if (elementSplit.length === 2) {
						result["modifier"].push(elementSplit[1]);
					}
				}
			}
		});

		return result;
	}

	function getModifierClass(baseClass, modifier) {
		return baseClass + options.modifierSeparator + modifier;
	}

	var elementMethods = {

	};

	function bemElementQuery(method, elements) {
		var info = getClasses(this),
			elementClass = options.prefix + info["block"] + options.elementSeparator + elements,
			query = "." + elementClass,
			result = this[method](query);

		$.extend(result, elementMethods, {
			__bem_element_class: elementClass
		});

		return result;
	}

	$.fn.bemAddModifier = function(modifier) {
		var info = getClasses(this);

		if (info.element) {
			this.addClass([options.prefix, info.block, options.elementSeparator, info.element, options.modifierSeparator, modifier].join(""))
		} else {
			this.addClass([options.prefix, info.block, options.modifierSeparator, modifier].join(""))
		}

		return this;
	};

	$.fn.bemHasModifier = function(modifier) {
		var info = getClasses(this),
			className = info.element
				? [options.prefix, info.block, options.elementSeparator, info.element, options.modifierSeparator, modifier].join("")
				: [options.prefix, info.block, options.modifierSeparator, modifier].join("");

		return this.hasClass(className);
	};

	$.fn.bemRemoveModifier = function(modifier) {
		var info = getClasses(this);

		if (info.element) {
			this.removeClass([options.prefix, info.block, options.elementSeparator, info.element, options.modifierSeparator, modifier].join(""))
		} else {
			this.removeClass([options.prefix, info.block, options.modifierSeparator, modifier].join(""))
		}

		return this;
	};

	$.fn.bemParents = function(elements) {
		return bemElementQuery.call(this, "parents", elements);
	};

	$.fn.bemSiblings = function(elements) {
		return bemElementQuery.call(this, "siblings", elements);
	};

	$.fn.bemGetElements = function(elements) {
		var info = getClasses(this),
			elementClass = options.prefix + info["block"] + options.elementSeparator + elements,
			query = "." + elementClass,
			result = this.find(query);

		$.extend(result, elementMethods, {
			__bem_element_class: elementClass
		});

		return result;
	};

	$.fn.findBlock = function(blockQuery) {
		return BEM.block(blockQuery, this);
	};

	var blockMethods = {
		getElements: function(element) {
			var elementClass = this.__bem_block_class + options.elementSeparator + element,
				query = "." + elementClass,
				result = this.find(query);

			$.extend(result, elementMethods, {
				__bem_element_class: elementClass
			});

			return result;
		},

		hasModifier: function(modifier) {
			var modifierClass = getModifierClass(this.__bem_block_class, modifier);
			return this.hasClass(modifierClass);
		},

		addModifier: function(modifier) {
			var modifierClass = getModifierClass(this.__bem_block_class, modifier);
			return this.addClass(modifierClass);
		},

		removeModifier: function(modifier) {
			var modifierClass = getModifierClass(this.__bem_block_class, modifier);
			return this.removeClass(modifierClass);
		}
	};

	var BEM = {
		block: function(blockQuery, parent) {
			var blockClass, query, result, info;

			if ("string" === typeof blockQuery) {
				blockClass = options.prefix + blockQuery;
				query = "." + blockClass;
				result = parent ? $(parent).find(query) : $(query);
			} else {
				info = getClasses(blockQuery);
				result = $(blockQuery);
				blockClass = options.prefix + info.block;
			}

			$.extend(result, blockMethods, {
				__bem_block_class: blockClass
			});

			return result;
		},

		buildBlockClassname: function(block, modifier) {
			var classname = options.prefix + block;

			if ("undefined" !== typeof modifier) {
				classname += options.prefix + modifierSeparator;
			}

			return classname;
		},

		buildElementClassname: function(block, element, modifier) {
			var classname = this.buildBlockClassname(block) + options.elementSeparator + element;

			if ("undefined" !== typeof modifier) {
				classname += options.modifierSeparator + modifier;
			}

			return classname;
		}
	};

	$.extend($.expr[":"], {
		modifier: function(element, index, details, collection) {
			return getClasses(element).modifier.indexOf(details[3]) >= 0;
		}
	});

	return BEM;
}));
